// extracted by mini-css-extract-plugin
module.exports = {"grid":"_1053","square":"_17213"};